import { owcTheme } from '@one/design-tokens/js/regular/navify/light';
import styled from 'styled-components';
import {
  SIGNATURE_HEIGHT,
  SIGNATURE_MAX_RENDERED_WIDTH,
  SIGNATURE_SCROLL_MARGIN,
  SIGNATURE_WIDTH,
} from './signature-pad.constants';

export const SignaturePadCanvas = styled.canvas`
  width: min(calc(100% - 2 * ${SIGNATURE_SCROLL_MARGIN}), ${SIGNATURE_MAX_RENDERED_WIDTH}px);
  aspect-ratio: ${SIGNATURE_WIDTH} / ${SIGNATURE_HEIGHT};
  border-radius: ${owcTheme['one-border-radius-16']};
  touch-action: none;

  &.empty {
    margin: 1px;
    border: 1px solid var(--one-color-interaction-default-intensity-medium);
  }

  &.filled {
    border: ${owcTheme['one-border-width-2']} solid var(--one-color-interaction-focus-brand-high);
  }
`;
